import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-screen',
  templateUrl: './privacy-policy-screen.component.html',
  styleUrls: ['./privacy-policy-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyScreenComponent {}
